'use strict';

export default class BlockAlert {
  constructor() {
    this.alertMembershipExpiry();
  }


  alertMembershipExpiry() {
    // just for testing purpose
    (function() {
      var alertBlock = $("<div/>", {
        id: 'block-views-block-alert',
        class: 'views-element-container',
        html: `
          <h2 class="title">Alerts <span class="count">1</span></h2>
          <div class="views-row">
          </div>
        `
      });

    //   $("#block-views-block-dashboard-news-carousel").after(alertBlock);
    })();

    var alertBlock = $("#block-views-block-alert");
    var personalMembershipBlock = $("#block-views-block-personal-membership");
    var expiryDate = personalMembershipBlock.find('.views-field-end-date .field-content').html();
    
    var parsedExpiryDate = new Date(Date.parse(expiryDate));
   
    var today = new Date();
    // var today = new Date(Date.parse('12 July, 2023'));
    var diffTime = Math.abs(parsedExpiryDate - today);
    const diffDays = (parsedExpiryDate - today) < 0 ? (Math.ceil(diffTime / (1000 * 60 * 60 * 24))) * -1 : Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    
    if(diffDays > 30) return;

    var message = "";
    
    if(diffDays < 1) message = "Your membership is expired. Please renew to continue.";
    else message = "Your membership is about to expired. Please renew to continue.";
    var template = this.getTemplate(
      'notice',
      {
        title: "Membership Expiry",
        message: message,
        action: '/renew-membership'
      }
    );
    
    alertBlock.find('.views-row').append(template);
    alertBlock.show();
  }

  /**
   * 
   * @param { String } type 
   * @param { title, message, action } data 
   * @returns { String }
   */
  getTemplate(type = 'success',data) {
    
    return `
      <div class="box-alert row_nw">
          <div class="alert-icon">
            ${this.getIcon(type)}
          </div>
          <div class="content">
              <div class="title">${data.title}</div>
              <div class="message">${data.message}</div>
          </div>
          <div class="actions">
              <a href="${data.action}">Find out more</a>
          </div>
      </div>
    `;

  }

  getIcon(type) {
    var iconSrc = "/themes/aba/images/alert.svg";
    switch(type) {
      case 'success':
        break;
      default:
        break;
    }

    return `<img class="icon" src=${iconSrc}>`;
  }
}
